<template>
  <div>
    <div class="row">
      <div class="col-md">
        <div class="portlet">
          <div class="portlet-head">
            <h3><i class="fas fa-building"></i> Firmy</h3>
            <div v-if="isNotSubcontractor">
              <b-button
                @click="showModal(null, 'company-info-modal')"
                variant="outline-primary"
              >
                <i class="fas fa-plus"></i> Dodaj Firmę
              </b-button>
            </div>
          </div>
          <div class="portlet-body">
            <b-table
            class="table table-sm table-list table-mobile"
            id="companies"
            ref="companies_table"
            :tbody-tr-class="rowClass"
            :fields="fields"
            :busy.sync="isBusy"
            :items="items"
            stacked="xl"
            >
            <template v-slot:table-busy>
              <TableSpiner />
            </template>
            <template v-slot:cell(address)="data">
              {{ data.item.address }}<br />
              {{ data.item.postalcode }}, {{ data.item.city }} {{ data.item.country }}
            </template>
            <template v-slot:cell(options)="data">
              <b-dropdown no-caret right variant="light" class="btn-rounded">
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button
                  @click="showModal(data.item.id, 'company-info-modal')"
                  >Edytuj</b-dropdown-item-button
                >
                <div v-if="data.item.main_company != 1">
                  <b-dropdown-item-button
                    @click="setAsMain(data.item.id)"
                    >Ustaw jako główną firmę</b-dropdown-item-button
                  >
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    @click="confirmRemove(data.item)"
                    class="danger"
                  >
                    <i class="fas fa-trash-alt"></i> Usuń
                  </b-dropdown-item-button>
                </div>
              </b-dropdown>
            </template>
          </b-table>
          </div>
        </div>
      </div>
    </div>

    <CompaniesModalFormInfo
      :company="selected"
      v-on:onClose="this.handleDeselect"
      v-on:onSubmit="this.handleSubmit"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableSpiner from "../components/TableSpiner";
import CompaniesModalFormInfo from "../components/companies/CompaniesModalFormInfo";

export default {
  name: "TheCompanies",
  components: {
    TableSpiner,
    CompaniesModalFormInfo,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "name", label: "Nazwa" },
        { key: "address", label: "Adres" },
        { key: "vatnumber", label: "NIP" },
        { key: "vat_rate", label: "Stawka VAT" },
        { key: "currency", label: "Waluta" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
      selected: null,
    };
  },
  mounted() {
    this.getData();
     if(this.isNotSubcontractor === false){
         this.fields.pop();
     }
  },
  computed: {
    ...mapGetters("company", ["items", "mainCompany"]),
    ...mapGetters("user", ["isNotSubcontractor"]),
  },
  methods: {
    ...mapActions("company", ["getCompanies", "removeCompany", "setMainCompany"]),
    getData() {
      this.isBusy = true;
      return this.getCompanies()
        .then(() => {
          this.isBusy = false;
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    confirmRemove(company) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć firmę ",
              h("strong", company.name),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie firmy",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.removeCompany(company.id).then(() => {
            this.$refs.companies_table.refresh();
          });
        });
    },
    setAsMain(companyId) {
      this.$Progress.start();
      this.setMainCompany(companyId)
        .then(() => {
          this.$refs.companies_table.refresh();
        });
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.main_company == 1) return 'table-info'
    },
    showModal(companyId, modalid) {
      if (companyId) {
        this.selected = this.$_.find(this.items, { id: companyId });
      }
      this.$nextTick(() => {
        this.$bvModal.show(modalid);
      });
    },
    handleSubmit: function() {
      this.$refs.companies_table.refresh();
      this.$nextTick(() => {
        this.$bvModal.hide("company-info-modal");
      });
    },
    handleDeselect: function () {
      this.selected = {};
    },
  }
};
</script>
